export class GitProvidersRepository {
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.url = model.url;
        this.defaultBranch = model.defaultBranch;
        this.slug = model.slug;
    }
}
export class GitProvidersRepositories {
    constructor(model) {
        this.repositories = model.repositories.map((repository) => new GitProvidersRepository(repository));
    }
}
